import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NxWelcomeComponent } from './nx-welcome.component';
import { BillingComponent } from './components/billing/billing.component';
import { BureauComponent } from './components/bureau/bureau.component';
import { MonthlyBillingComponent } from './components/monthly-billing/monthly-billing.component';
import { ReportsComponent } from './components/reports/reports.component';
import { HomeComponent } from './components/home/home.component';

import { CommonModule } from '@angular/common';
import { AddNewClientComponent } from './components/Add-New-Client/Add-New-Client.component';
@Component({
  standalone: true,
  imports: [CommonModule,NxWelcomeComponent, RouterModule, BillingComponent,BureauComponent,MonthlyBillingComponent,ReportsComponent,
HomeComponent ,AddNewClientComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'frontend-client-management';
}
